import { render, staticRenderFns } from "./select-dept.vue?vue&type=template&id=09e973e3"
import script from "./select-dept.vue?vue&type=script&lang=js"
export * from "./select-dept.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports